import { IImage } from '@gn-audio/core/api/product-catalogue/models/image';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { Directive, Inject, Input, OnDestroy, OnInit } from 'angular-ts-decorators';

import galleryTemplate from './open-hero-customizer-v2-image-gallery.html';

const galleryVisibilityThreshold = 992;
const overflowHiddenCssClass = 'overflow-hidden';

interface IHeroCustomizerV2ImageGalleryScope extends ng.IScope {
  group?: IProductWithAttributes;
  images?: IImage[];
  onClose?: () => void;
}

@Directive({
  selector: '[openHeroCustomizerV2ImageGallery]',
})
export class OpenHeroCustomizerV2ImageGalleryDirective implements OnInit, OnDestroy {
  public static $inject: ReadonlyArray<string> = ['$element', '$window', '$compile', '$rootScope'];

  @Input() public images?: IImage[];
  @Input() public group?: IProductWithAttributes;

  private openedGalleryElement?: JQLite;
  private openedGalleryScope?: IHeroCustomizerV2ImageGalleryScope;
  private bodyElement?: HTMLBodyElement;

  constructor(
    @Inject('$element') private $element: JQLite,
    @Inject('$window') private $window: ng.IWindowService,
    @Inject('$compile') private $compile: ng.ICompileService,
    @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
  ) { }

  public ngOnInit() {
    this.bodyElement = document.documentElement.querySelector('body');
    this.$element.on('click', this.openGallery.bind(this));
    this.$window.addEventListener('resize', this.onWindowResize.bind(this));
  }

  public ngOnDestroy() {
    this.$element.off('click', this.openGallery);
    this.$window.removeEventListener('resize', this.onWindowResize);
  }

  private onWindowResize() {
    if (this.$window.innerWidth > galleryVisibilityThreshold) {
      return;
    }

    this.closeGallery();
  }

  private openGallery() {
    this.openedGalleryScope = this.$rootScope.$new();
    this.openedGalleryScope.images = this.images || [];
    this.openedGalleryScope.group = this.group;
    this.openedGalleryScope.onClose = this.closeGallery.bind(this);
    this.openedGalleryElement = this.$compile(galleryTemplate)(this.openedGalleryScope);
    this.bodyElement.classList.add(overflowHiddenCssClass);
    this.openedGalleryElement.appendTo(this.bodyElement);
  }

  private closeGallery() {
    this.bodyElement.classList.remove(overflowHiddenCssClass);
    this.openedGalleryScope?.$destroy();
    this.openedGalleryElement?.remove();
  }
}
